import {useContext} from 'react'
import {PurchaserByBrandReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {PURCHASER_REPORT_COLUMNS} from '../../utils'
import {parsePurchaserByBrandReportRow} from '../../parsings'
import {formatPrice, formatToIndianNumber} from '../../../../utils/common'
import PurchaserByBrandReportRow from './PurchaserByBrandReportRow'

const PurchaserByBrandReportTable = () => {
  const {purchaserReportData, isPurchaserReportLoading, filters, onSortingChange} = useContext(PurchaserByBrandReportContext)

  return (
    <DynamicTable
      data={purchaserReportData}
      sortableColumns={PURCHASER_REPORT_COLUMNS}
      loading={isPurchaserReportLoading}
      TableRow={PurchaserByBrandReportRow}
      noDataMessage='No purchaser reports found'
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      filters={filters}
      onSortingChange={onSortingChange}
      rowParsingFunction={parsePurchaserByBrandReportRow}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td>TOTAL</td>
            <td>{formatToIndianNumber(columnTotals?.total_orders)}</td>
            <td>{formatPrice(columnTotals.total_cost, false)}</td>
            <td>{formatPrice(columnTotals.total_sales, false)}</td>
            <td>{formatPrice(columnTotals.total_profit, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default PurchaserByBrandReportTable
